import { render, staticRenderFns } from "./ProductDiscountSlabs.vue?vue&type=template&id=3140b129&"
import script from "./ProductDiscountSlabs.vue?vue&type=script&lang=js&"
export * from "./ProductDiscountSlabs.vue?vue&type=script&lang=js&"
import style0 from "./ProductDiscountSlabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports